import { render, staticRenderFns } from "./DpiSetting.vue?vue&type=template&id=1bd9c0a6&scoped=true"
import script from "./DpiSetting.vue?vue&type=script&lang=js"
export * from "./DpiSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9c0a6",
  null
  
)

export default component.exports